import {useState} from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import StockSaleProceedsWorksheet from "./Stock";
import AssetSaleProceedsWorksheet from "./Asset";

const STOCKSALE = "Stock"
const ASSETSALE = "Asset"

export default function Valuation() {
  // States
  const [selection, setSelection] = useState(STOCKSALE);

  // Methods
  const getSection = () => {
    switch(selection) {

      case STOCKSALE:
        return <StockSaleProceedsWorksheet />

      case ASSETSALE:
        return <AssetSaleProceedsWorksheet />

      default:
        break
    }
  }

  return (
    <>
        <div className="flex items-center justify-between pr-20">
            <h2 className="sectionHead">{selection} Sale Proceeds Worksheet</h2>
            <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
            <InputLabel id="demo-simple-select-standard-label">Sale Type</InputLabel>
            <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selection}
                onChange={(e) => setSelection(e.target.value)}
                label="Sale Type"
            >
                <MenuItem value={STOCKSALE}>Stock Sale</MenuItem>
                <MenuItem value={ASSETSALE}>Asset Sale</MenuItem>
            </Select>
            </FormControl>
        </div>
        {getSection()}
    </>
  )
}
